import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import Routes from './components/route/Routes';
import store from './store';
import 'antd/dist/antd.css';
import './index.css';
import './i18n';
import ReactGa from 'react-ga4';
import { EmploymentTypesProvider } from './hooks/useEmploymentTypes';

function App() {
  useEffect(() => {
    process.env.REACT_APP_GOOGLE_ANALYTICS_ID &&
      ReactGa.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_ID);
  }, []);
  return (
    <div className="App">
      <Provider store={store}>
        <EmploymentTypesProvider>
          <Routes />
        </EmploymentTypesProvider>
      </Provider>
    </div>
  );
}

export default App;
